/* eslint-disable no-unused-vars */
import { api } from '@/services';

export default {
  async fetchDataAcuraciaPorUnidade({ commit }, payload) {
    const { data } = await api.get('/armazenagem/acuracia-estoque/acuracia-por-unidade');
    commit('SET_ACURACIA_POR_UNIDADE', data);
  },
  async fetchDataAcuraciaPorCliente({ commit }, payload) {
    const { data } = await api.get('/armazenagem/acuracia-estoque/acuracia-por-cliente');
    commit('SET_ACURACIA_POR_CLIENTE', data);
  },
  async fetchDataAcuraciaMensal({ commit }, payload) {
    const { data } = await api.get('/armazenagem/acuracia-estoque/acuracia-mensal');
    commit('SET_ACURACIA_MENSAL', data);
  },
  async fetchDataAcuraciaQuantidadeItensCliente({ commit }, payload) {
    const { data } = await api.get('/armazenagem/acuracia-estoque/produto-cliente-total');
    commit('SET_ACURACIA_QUANTIDADE_ITEM_CLIENTE', data);
  },
  async fetchDataAcuraciaQuantidadeInventariadaProduto({ commit }, payload) {
    const { data } = await api.get('/armazenagem/acuracia-estoque/quantidade-inventariada-produto');
    commit('SET_ACURACIA_QUANTIDADE_INVENTARIADA_PRODUTO', data);
  },
  async fetchDataAcuraciaCardsInformativos({ commit }, payload) {
    const { data } = await api.get('/armazenagem/acuracia-estoque/informacoes-estoque');
    commit('SET_ACURACIA_INFORMACOES_ESTOQUE', data);
  },
};
